import Integrations from './integrations/IntegrationsSetup.js'

export default { install : ( molten ) => {
  molten.addPlugin( 'Molten.blueprintRelationshipProcessor', {
    id : 'integrations.routes',
    type : 'integrations.routes',
    processRelationship : Integrations
  } )
} } 
